var _defs, _ellipse, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_3745",
    "data-name": "Grupo 3745",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 31.911,
    viewBox: "0 0 32 31.911",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M11.381,14.6a4.863,4.863,0,0,0-9.725,0H0a6.518,6.518,0,0,1,13.036,0ZM2.776,3.731a3.742,3.742,0,1,1,3.742,3.73A3.741,3.741,0,0,1,2.776,3.731Zm1.657,0A2.086,2.086,0,1,0,6.518,1.651,2.084,2.084,0,0,0,4.433,3.731Z",
    fill: "#1a1446"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 16,
    cy: 15.956,
    rx: 16,
    ry: 15.956,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_User",
    "data-name": "Icon/User",
    transform: "translate(10.017 9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color_Liberty_Blue",
    "data-name": "Color/Liberty Blue"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask-2",
    "data-name": "Mask",
    d: "M11.381,14.6a4.863,4.863,0,0,0-9.725,0H0a6.518,6.518,0,0,1,13.036,0ZM2.776,3.731a3.742,3.742,0,1,1,3.742,3.73A3.741,3.741,0,0,1,2.776,3.731Zm1.657,0A2.086,2.086,0,1,0,6.518,1.651,2.084,2.084,0,0,0,4.433,3.731Z",
    fill: "#1a1446"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color_Liberty_Blue-2",
    "data-name": "Color/Liberty Blue",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color_Liberty_Blue-3",
    "data-name": "Color/Liberty Blue",
    transform: "translate(-45.125 -45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Copy",
    "data-name": "Rectangle Copy",
    width: 101.281,
    height: 97,
    fill: "#1a1446"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f9e015973f12dd0c6d856bd3b8e93366.svg";
export { ForwardRef as ReactComponent };